module.exports = __webpack_public_path__ + "img/18102259000370.d49cb40a.png";